<template>
	<div class="m-activity flex">
		<div class="m-activity-info">
			<p class="title">{{unitData.title}}</p>
			<p class="text">活动优惠即将结束</p>
			<div class="countdown flex-center">
				<div>7</div>
				<span>天</span>
				<div>18</div>
				<span>:</span>
				<div>10</div>
				<span>:</span>
				<div>20</div>
			</div>
		</div>
		<div class="m-activity-list flex-grow">
			<div class="scroll-list">
				<div class="flex">
					<a v-for="(item, i) in unitData.product_list" :key="item.product_id" class="item">
						<c-image class="image" :src="item.product_img_url"></c-image>
						<p class="ellipsis">{{item.product_name}}</p>
						<div>￥{{item.sale_price}}</div>
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				unitData: {}
			}
		},
		
		mounted() {
		},
		
		methods: {
		}
	}
</script>

<style lang="stylus" scoped>
	.m-activity {
		margin-top: 24px;
		background: #fff;
		
		&-info {
			box-sizing: border-box;
			width: 230px;
			height: 300px;
			padding-top: 28px;
			color: #fff;
			background: linear-gradient(0deg, #DE0000, #FF3C00);
			
			.title {
				position: relative;
				line-height: 68px;
				font-size: 30px;
				font-weight: bold;
				text-align: center;
				
				&:after {
					content: '';
					position: absolute;
					left: 50%;
					bottom: 0;
					width: 50px;
					height: 3px;
					margin-left: -25px;
					background: #fff;
				}
			}
			
			.text {
				margin: 102px 0 28px;
				font-size: 14px;
				text-align: center;
			}
			
			.countdown {
				div {
					width: 32px;
					height: 32px;
					border-radius: 2px;
					line-height: 32px;
					font-size: 16px;
					text-align: center;
					background: #000;
				}
				
				span {
					margin: 0 6px;
					font-size: 16px;
				}
			}
		}
		
		&-list {
			position: relative;
			overflow: hidden;
			
			.scroll-list {
				padding: 0 27px;
			}
			
			.item {
				min-width: 200px;
				margin-top: 24px;
				
				&:nth-child(n+2) {
					margin-left: 29px;
				}
				
				.image {
					height: 200px;
				}
				
				p {
					line-height: 38px;
					font-size: 13px;
					text-align: center;
				}
				
				div {
					line-height: 26px;
					font-size: 16px;
					font-weight: bold;
					text-align: center;
					color: #DE0000;
				}
			}
		}
	}
</style>
